import { render, staticRenderFns } from "./ApplicationFee.vue?vue&type=template&id=7bbff6d6&scoped=true"
import script from "./ApplicationFee.vue?vue&type=script&lang=js"
export * from "./ApplicationFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbff6d6",
  null
  
)

export default component.exports